import { useUserDocumentList } from 'api/goodtrust/user/document'
import { Button } from 'components/button/Button'
import { DocumentList } from 'components/document/documentList/DocumentList'
import { SectionEmptyState } from 'components/sectionEmptyState/SectionEmptyState'
import { BlockSpinner } from 'components/spinner/Spinner'
import { useTranslation } from 'next-i18next'
import { VFC } from 'react'
import { getPaginationMeta } from 'utils/pagination'

export const DocumentsTab: VFC = () => {
  const { t } = useTranslation('digital_vault')
  const documents = useUserDocumentList()
  const meta = getPaginationMeta(documents)

  return (
    <>
      {!documents.data ? (
        <BlockSpinner />
      ) : meta.isEmpty ? (
        <SectionEmptyState
          icon="DocumentReady"
          title={t('digital_vault.inside_page.docs_tab.title')}
          description={t('digital_vault.inside_page.docs_tab.desc')}
          buttons={
            <>
              <Button href={'/me/document/add'} type="button">
                {t('digital_vault.inside_page.docs_tab.button')}
              </Button>
            </>
          }
        />
      ) : (
        <DocumentList
          title={t('digital_vault.inside_page.docs_tab.docs_list_title')}
          onDataChange={documents.mutate}
        />
      )}
    </>
  )
}
